import { AxiosInstance } from 'axios';

export interface HandoffApi {
  createHandoffToken: () => Promise<{ handoff_token: string }>;
}

export const useHandoffApi = (fetch, rawAxios: AxiosInstance): HandoffApi => {
  const createHandoffToken = async (): Promise<{ handoff_token: string }> => {
    const response = await fetch('/auth/handoff/create', {});
    return response.data;
  };

  return { createHandoffToken };
};
